<template>
  <router-link :to="pathTo" class="icon-button" :class="{ active }">
    <img class="icon-button__icon" :src="icon" alt="" />
  </router-link>
</template>

<script setup>
  import {useRoute} from "vue-router";
  import {computed} from "vue";

  const props = defineProps({
    icon: String,
    path: String,
    active: Boolean,
  });

  const route = useRoute();

  const pathTo = computed(() => {
    return {
      name: route.name,
      params: route.params,
      query: route.query,
      hash: props.path,
    };
  });
</script>

<style lang="scss">
  @use "@/assets/styles/_colors.scss" as *;

  .icon-button {
    height: 32px;
    width: 32px;
    padding: 2px;
    border-radius: 2px;
    border: 2px solid $color-bg-primary-white;
    background-color: $color-bg-primary-white;

    .icon-button__icon {
      width: 24px;
      height: 24px;
      flex: 0 0 24px;

      &:hover,
      &:focus {
        filter: invert(75%) sepia(24%) saturate(4159%) hue-rotate(44deg)
          brightness(100%) contrast(77%);
      }
    }

    &:hover,
    &:focus {
      border-color: $color-bg-secondary-grey;
      background-color: $color-bg-secondary-grey;
    }

    &:active {
      border-color: $color-btn-primary-active;
      background-color: $color-bg-secondary-grey;
    }

    &.active {
      .icon-button__icon {
        filter: invert(75%) sepia(24%) saturate(4159%) hue-rotate(44deg)
          brightness(100%) contrast(77%);
      }
    }
  }
</style>
